<template>
  <modal name="marcaEdit" height="auto" width="900" :scrollable="true" :clickToClose="true">
    <div class="modalbox">
      <div class="modalbox-content">
        <div class="row">
          <ul class="tabs">
            <li class="tab-active">
              <a>Editando Marca</a>
            </li>
          </ul>
        </div>
        <div class="form">
          <div class="row">
            <div class="col-2-3">
              <div class="form-group">
                <label for="">Link</label>
                <input type="text" v-model="item.link" class="form-control">
                <div class="message">{{ validation.firstError('item.link') }}</div>
              </div>
            </div>
            <div class="col-1-3">
              <div class="form-group">
                <label for="">Ordem</label>
                <input type="number" v-model="item.ordem" class="form-control">
                <div class="message">{{ validation.firstError('item.ordem') }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="form-actions">
            <button :class="{ 'button button-success button-lg': true, 'button-disabled': validation.hasError() }" v-on:click="handleSubmit">
              Alterar
            </button>
            <button class="button button-lg" v-on:click="close">Fechar</button>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
import SimpleVueValidation from 'simple-vue-validator'
import { getImage } from '../../helpers/utils'
const Validator = SimpleVueValidation.Validator

export default {
  name: 'marcaEdit',
  props: ['item', 'update', 'close'],
  data () {
    return {
    }
  },
  validators: {
    'item.link': function (value) {
      return Validator.value(value).required()
    },
    'item.ordem': function (value) {
      return Validator.value(value).required().digit()
    }
  },
  methods: {
    handleSubmit () {
      this.$validate()
        .then(success => {
          console.log('success', success)
          if (success) {
            this.update()
          }
        })
    },
    getImage: getImage
  }
}
</script>


// WEBPACK FOOTER //
// src/views/Marcas/Edit.vue